import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CardSeplagScrol from "../../../../components/CardSeplag/CardSeplagScrol";
import QuestionarioSeplag from "../../../../components/QuestionarioSeplag";
import Regua2024 from "../../../../components/Regua2024";
import Rotulo from "../../../../components/RotuloSeplag";
import { printToast } from "../../../../config/global";
import {
  salvarAvaliacaoAcao,
  salvarAvaliacaoAcao2024,
  salvarRealizadoRegiaoPlan,
  uploadArquivoRAG,
} from "../../../../service/Rag/AvaliacaoAcao";
import { buscarItemAcao2024 } from "../../../../service/Rag/AvaliacaoPrograma";

const AvaliacaoAcaoRagMetaFisica = (props) => {
  const [campos, setCampos] = useState(JSON.parse(props.questionario));
  const [form, setForm] = useState();
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const [listaProdutos, setListaProdutos] = useState(null);
  const [listaProdutosAnalise, setListaProdutosAnalise] = useState([]);
  const [listaMetaPtaFiplanRegPlan, setListaMetaPtaFiplanRegPlan] = useState(null);
  const [vlrTotal, setVlrTotal] = useState(null);
  const [porcentagemPrevistoInicial, setPorcentagemPrevistoInicial] = useState(0);
  const [porcentagemPrevistoAtualizado, setPorcentagemPrevistoAtualizado] = useState(0);
  const [arquivo, setArquivo] = useState("");
  const [v_nomeArquivo, setNomeArquivo] = useState(""); // Estado para armazenar o nome do arquivo
  const [v_idenArquivo, setIdenArquivo] = useState(null);
  const [v_nomeArquivoNovo, setNomeArquivoNovo] = useState(""); // Estado para armazenar o nome do arquivo
  const [idenProdutoSelecionado, setIdenProdutoSelecionado] = useState(null);
  const [arquivoSelecionado, setArquivoSelecionado] = useState();

  const [isPercent, setIsPercent] = useState(reguaState);
  const reguaState = {
    PrevistoInicial: {
      percent60: false,
      percent80: false,
      percent90: false,
      percent100: false,
      percent110: false,
      percent120: false,
      percent140: false,
    },
    PrevistoAtualizado: {
      percent60: false,
      percent80: false,
      percent90: false,
      percent100: false,
      percent110: false,
      percent120: false,
      percent140: false,
    },
  };

  const setarIntervaloReguaTrue = (previstoObjeto, atributoObjeto) => {
    for (let key in reguaState[previstoObjeto]) {
      if (key == atributoObjeto) {
        reguaState[previstoObjeto][key] = true;
      } else {
        reguaState[previstoObjeto][key] = false;
      }
    }
    setIsPercent(reguaState);
  };

  let history = useHistory();

  useEffect(() => {
    setListaProdutos(props.dadosItemAcao.produtoAcao);
    //buscarNomeArquivo();
    //console.log('campos:', campos);
  }, [v_idenArquivo]);

  useEffect(() => {
    //setIdenArquivo(encontrarIdenArquivo());
    //if (listaProdutosAnalise && listaProdutosAnalise.length === 0) {
    //setListaProdutosAnalise(listaProdutos); //copia a Lista Produtos para utilizar na Analise atraves do ListaProdutosAnalise

    !exercicio2024 && setListaProdutosAnalise(listaProdutos); //copia a Lista Produtos para utilizar na Analise atraves do ListaProdutosAnalise

    //console.log("Inicializacao >> ", listaProdutosAnalise);
    //}
  }, [listaProdutosAnalise]);

  useEffect(() => {
    setCampos(JSON.parse(props.questionario)); //atualizacao dos campos do componente no questionario
  }, [props.questionario]);

  const onChangeProduto = async (e) => {
    //console.log("onChangeProduto")
    setListaMetaPtaFiplanRegPlan(null);
    setProdutoSelecionado(e.value ? e.value : null);
    // console.log(produtoSelecionado.ptaFiplan.codgElemento + " " + produtoSelecionado.ptaFiplan.idenPtaFiplan + " " + e.value.ptaFiplan.produto.idenProduto)

    //console.log("e", e.value)
    //buscar o valores do produto para atualizar na questionario
    //console.log("TESTESTTTTT ", e.value.ptaFiplan.produto.idenProduto, " ", e.value.ptaFiplan.idenPtaFiplan )

    setIdenProdutoSelecionado(e.value.ptaFiplan.produto.idenProduto);
    //console.log("setIdenProdutoSelecionado PRODUTOSETADO",idenProdutoSelecionado)
    //console.log("Iden do Produto selecionado",e.value.ptaFiplan.produto.idenProduto)

    const res = await buscarItemAcao2024(e.value.ptaFiplan.produto.idenProduto, e.value.ptaFiplan.idenPtaFiplan);
    //debugger
    //console.log("res", res.data)
    //console.log("campos",campos)

    if (res.data.length == 0) {
      setIdenArquivo(null); //Inicializa sem arquivo
      //Tratamento para quando nao encontrar o arquivo
      //console.log("NaoexisteRES")
      let v_campos_doisvazio = campos.map((questao, i) => {
        return {
          ...questao,
          data: "",
          codigoItemRag: 0,
          idenRespostaItemQuest: 0,
          valrRespostaItemQuest: "",
          idenArquivo: null,
        };
      });
      setCampos(v_campos_doisvazio);
    } else {
      //console.log("EXISTE_RES")
      //let lista_questoes = JSON.parse(JSON.stringify(res.data.reverse()));  //inverte a ordem do res.data, pq a idenQuestionarioPergunta em outra ordem
      //console.log("res.data[i]", res.data);
      //console.log("listaquestoes", lista_questoes);
      // console.log("listaquestoes",lista_questoes)

      let v_campos_dois = campos.map((questao, i) => {
        //console.log("questao2",questao)
        if (res.data[i].produto?.idenProduto) {
          //debugger

          // console.log(i)

          let idAuxArquivo = 0;
          if (
            questao.type === "LISTA" &&
            res.data[i].valrRespostaItemQuestAcao === "Sim" &&
            res.data[i].arquivoRag?.idenArquivo != null
          ) {
            idAuxArquivo =
              res.data[i]?.arquivoRag?.idenArquivo == null || undefined ? null : res.data[i].arquivoRag.idenArquivo;
            setIdenArquivo(idAuxArquivo);
            //console.log("idAuxArquivo Ponto Pelo Questionario", idAuxArquivo)
          } else {
            setIdenArquivo(null); //Quando nao encontrar o arquivo
            //console.log("SetaValorNullParaArquivo")
          }

          return {
            ...questao,
            data: res.data[i].valrRespostaItemQuestAcao,
            codigoItemRag: res.data[i].produto.idenProduto,
            idenRespostaItemQuest: res.data[i].idenRespostaItemQuestAcao,
            valrRespostaItemQuest: res.data[i].valrRespostaItemQuestAcao,
            idenArquivo:
              res.data[i]?.arquivoRag?.idenArquivo == null || undefined ? null : res.data[i].arquivoRag.idenArquivo,
          };
        }
      });

      setCampos(v_campos_dois);
    }

    atualizarListaProdutoAnalise2024(e);

    let listaMeta = e.value.produtoAcaoRegiao.map((item) => {
      let valorStr =
        item.realizadoPtaMonRgPla != null && item.realizadoPtaMonRgPla.valrRealizado
          ? item.realizadoPtaMonRgPla.valrRealizado.toString()
          : "0.00";

      if (item.realizadoPtaMonRgPla) {
        item["valrRealizadoTxt"] = formatarValor(valorStr);
        return { ...item };
      }

      return {
        ...item,
        valrRealizadoTxt: "0,00",
        realizadoPtaMonRgPla: {
          valrRealizado: 0,
        },
      };
    });

    let ProdutoPrevistoInicialAux = 0;
    let ProdutoPrevistoAtualizadoAux = 0;
    let ProdutoPrevistoRealizadoAux = 0;
    if (listaMeta.length > 0) {
      let aux = {
        descRegiaoPlanejamento: "TOTAL",

        valrMetaOriginal: listaMeta.reduce((acc, current) => acc + current.valrMetaOriginal, 0),
        valrMetaAtualizada: listaMeta.reduce((acc, current) => acc + current.valrMetaAtualizada, 0),
        valrRealizadoTxt: listaMeta.reduce(
          (acc, current) => acc + parseFloat(current.realizadoPtaMonRgPla.valrRealizado),
          0
        ),
        realizadoPtaMonRgPla: {
          valrRealizado: listaMeta.reduce(
            (acc, current) => acc + parseFloat(current.realizadoPtaMonRgPla.valrRealizado),
            0
          ),
        },
      };
      ProdutoPrevistoInicialAux = aux.valrMetaOriginal == null || aux.valrMetaOriginal == 0 ? 0 : aux.valrMetaOriginal;
      ProdutoPrevistoAtualizadoAux =
        aux.valrMetaAtualizada == null || aux.valrMetaAtualizada == 0 ? 0 : aux.valrMetaAtualizada;
      ProdutoPrevistoRealizadoAux =
        aux.realizadoPtaMonRgPla.valrRealizado == null || aux.realizadoPtaMonRgPla.valrRealizado == 0
          ? 0
          : aux.realizadoPtaMonRgPla.valrRealizado;
      setListaMetaPtaFiplanRegPlan([...listaMeta, aux]);
    }

    let total = [
      {
        ProdutoPrevistoInicial: ProdutoPrevistoInicialAux,
        ProdutoPrevistoAtualizado: ProdutoPrevistoAtualizadoAux,
        ProdutoPrevistoRealizado: ProdutoPrevistoRealizadoAux,
        PercRealizadoPrevistoInicial:
          ProdutoPrevistoRealizadoAux && ProdutoPrevistoInicialAux
            ? (ProdutoPrevistoRealizadoAux / ProdutoPrevistoInicialAux) * 100
            : 0,
        PercRealizadoPrevistoAtualizado:
          ProdutoPrevistoRealizadoAux && ProdutoPrevistoAtualizadoAux
            ? (ProdutoPrevistoRealizadoAux / ProdutoPrevistoAtualizadoAux) * 100
            : 0,
      },
    ];

    let previstoInicial = 0;
    let previstoAtualizado = 0;

    if (total[0].ProdutoPrevistoInicial == null || total[0].ProdutoPrevistoInicial == 0) {
      previstoInicial = 0;
    } else {
      previstoInicial = (total[0].ProdutoPrevistoRealizado / total[0].ProdutoPrevistoInicial) * 100;
    }

    if (total[0].ProdutoPrevistoAtualizado == null || total[0].ProdutoPrevistoAtualizado == 0) {
      previstoAtualizado = 0;
    } else {
      previstoAtualizado = (total[0].ProdutoPrevistoRealizado / total[0].ProdutoPrevistoAtualizado) * 100;
    }

    setVlrTotal(total);
    setPorcentagemPrevistoInicial(previstoInicial);
    setPorcentagemPrevistoAtualizado(previstoAtualizado);

    reguaPrevistoInicial(previstoInicial);
    reguaPrevistoAtualizado(previstoAtualizado);
  };

  function calcularTotal(idenPtaFiplan) {
    let acc = 0.0;
    let vlrRealizado_ = 0;
    listaMetaPtaFiplanRegPlan.forEach((item) => {
      if (item.descRegiaoPlanejamento != "TOTAL") {
        if (item.valrRealizadoTxt) {
          let str = item.valrRealizadoTxt.replaceAll(".", "").replace(",", ".");
          let vlr = parseFloat(str);
          acc += vlr;
        } else {
          item.valrRealizadoTxt = 0.0;
        }
      }
    });

    listaMetaPtaFiplanRegPlan[listaMetaPtaFiplanRegPlan.length - 1].valrRealizadoTxt = acc.toFixed(2);

    /* atualizar tabela com campos [Produto Realizado] [% Realizado / Previsto Inicial] [% Realizado / Previsto Atualizado]*/
    let total = vlrTotal;

    let previstoInicial = 0;
    let previstoAtualizado = 0;

    total[0].ProdutoPrevistoRealizado = parseFloat(acc.toFixed(2));
    if (total[0].ProdutoPrevistoInicial == null || total[0].ProdutoPrevistoInicial == 0) {
      total[0].PercRealizadoPrevistoInicial = 0;
    } else {
      total[0].PercRealizadoPrevistoInicial =
        (total[0].ProdutoPrevistoRealizado / total[0].ProdutoPrevistoInicial) * 100;
    }

    if (total[0].ProdutoPrevistoAtualizado == null || total[0].ProdutoPrevistoAtualizado == 0) {
      total[0].PercRealizadoPrevistoAtualizado = 0;
    } else {
      total[0].PercRealizadoPrevistoAtualizado =
        (total[0].ProdutoPrevistoRealizado / total[0].ProdutoPrevistoAtualizado) * 100;
    }

    if (total[0].ProdutoPrevistoInicial == null || total[0].ProdutoPrevistoInicial == 0) {
      previstoInicial = 0;
    } else {
      previstoInicial = (total[0].ProdutoPrevistoRealizado / total[0].ProdutoPrevistoInicial) * 100;
    }
    if (total[0].ProdutoPrevistoAtualizado == null || total[0].ProdutoPrevistoAtualizado == 0) {
      previstoAtualizado = 0;
    } else {
      previstoAtualizado = (total[0].ProdutoPrevistoRealizado / total[0].ProdutoPrevistoAtualizado) * 100;
    }

    setVlrTotal(total);
    setPorcentagemPrevistoInicial(previstoInicial);
    setPorcentagemPrevistoAtualizado(previstoAtualizado);

    reguaPrevistoInicial(previstoInicial);
    reguaPrevistoAtualizado(previstoAtualizado);

    atualizarVlrRealizadoAbaAnalise(idenPtaFiplan, acc.toFixed(2));
  }

  function atualizarVlrRealizadoAbaAnalise(idenPtaFiplan, vlrRealizado_) {
    let dadosProdutos = props.dadosItemAcao.produtoAcao.map((e) => {
      if (e.ptaFiplan.idenPtaFiplan === idenPtaFiplan) {
        e.valrRealizado = vlrRealizado_;
      }
      return e;
    });

    let dadosItemAcao = props.dadosItemAcao;
    dadosItemAcao.produtoAcao = dadosProdutos;
    //console.log(dadosProdutos);
    //setListaProdutos(null);
    //props.setDadosItemAcao(dadosItemAcao);
    //setListaProdutos(dadosProdutos);
    //setListaProdutos(dadosProdutos);
    //console.log("## dadosProdutos");
    //console.log(dadosProdutos);
  }

  function reguaPrevistoInicial(previstoInicial) {
    if (previstoInicial <= 60) {
      setarIntervaloReguaTrue("PrevistoInicial", "percent60");
      return;
    }
    if (previstoInicial <= 80) {
      setarIntervaloReguaTrue("PrevistoInicial", "percent80");
      return;
    }
    if (previstoInicial <= 90) {
      setarIntervaloReguaTrue("PrevistoInicial", "percent90");
      return;
    }
    if (previstoInicial <= 100) {
      setarIntervaloReguaTrue("PrevistoInicial", "percent100");
      return;
    }
    if (previstoInicial <= 110) {
      setarIntervaloReguaTrue("PrevistoInicial", "percent110");
      return;
    }
    if (previstoInicial <= 120) {
      setarIntervaloReguaTrue("PrevistoInicial", "percent120");
      return;
    }
    if (previstoInicial > 120) {
      setarIntervaloReguaTrue("PrevistoInicial", "percent140");
      return;
    }
  }

  function reguaPrevistoAtualizado(previstoAtualizado) {
    if (previstoAtualizado <= 60) {
      setarIntervaloReguaTrue("PrevistoAtualizado", "percent60");
      return;
    }
    if (previstoAtualizado <= 80) {
      setarIntervaloReguaTrue("PrevistoAtualizado", "percent80");
      return;
    }
    if (previstoAtualizado <= 90) {
      setarIntervaloReguaTrue("PrevistoAtualizado", "percent90");
      return;
    }
    if (previstoAtualizado <= 100) {
      setarIntervaloReguaTrue("PrevistoAtualizado", "percent100");
      return;
    }
    if (previstoAtualizado <= 110) {
      setarIntervaloReguaTrue("PrevistoAtualizado", "percent110");
      return;
    }
    if (previstoAtualizado <= 120) {
      setarIntervaloReguaTrue("PrevistoAtualizado", "percent120");
      return;
    }
    if (previstoAtualizado > 120) {
      setarIntervaloReguaTrue("PrevistoAtualizado", "percent140");
      return;
    }
  }

  function formatarValor(value) {
    if (value == "0,00") {
      return "-";
    }
    return new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2 }).format(value);
    // if(!value) return '0,00'
    // let val = (value/1).toFixed(2).replace('.', ',')
    // return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }

  function VlrRealizadoFormatado(dados) {
    let dadosStr = dados.toString();
    let len = dadosStr.length;

    let strCheck = "0123456789e";
    let valueReturn = "";
    let aux = "";

    for (let i = 0; i <= len; i++) {
      if (strCheck.indexOf(dadosStr[i]) != -1) {
        aux += dadosStr[i];
      }
    }

    len = aux.length;
    if (len == 0) valueReturn = "0,000";
    if (len == 1) valueReturn = "0" + "," + "0" + aux;
    if (len == 2) valueReturn = "0" + "," + aux;
    if (len > 2) {
      let j = 0;
      let decimal = aux.substr(len - 2, len);
      let inteiro = parseInt(aux.substr(0, len - 2));
      let inteiroStr = inteiro.toString();

      let aux2 = "";

      if (inteiro == 0) {
        return "0," + decimal;
      }

      // for para montar a string no formato certo com pontos nos milhares
      for (let i = inteiroStr.length - 1; i >= 0; i--) {
        if (j == 3) {
          aux2 += ".";
          j = 0;
        }

        aux2 += inteiroStr[i];
        j++;
      }

      // for para reverter a string
      for (let i = aux2.length - 1; i >= 0; i--) {
        valueReturn += aux2[i];
      }

      valueReturn += "," + decimal;
    }

    return valueReturn;
  }

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  const salvar = async () => {
    let idArquivo = null;
    let invalid = false;
    let errorMessages = []; //Array para armazenar mensagens de erro

    // console.log("Salvar: ", idenProdutoSelecionado)
    if (exercicio2024 && idenProdutoSelecionado === null) {
      // console.log("ERRO_NAO_POSSUI_PRODUTO")
      invalid = true;
      printToast({ severity: "error", summary: "OBRIGATÓRIO", detail: `Selecione um produto para a Meta Física` });
    } else {
      let v_campos = await Promise.all(
        campos.map(async (questao, i) => {
          if (questao.flagObrigatorio === "S" && (questao.data == null || questao.data == "")) {
            // printToast({severity:"error", summary:"OBRIGATÓRIO", detail: `O item: ${i + 1} desta tela é de preenchimento obrigatório`});
            errorMessages.push(`O item: ${i + 1} desta tela é de preenchimento obrigatório`);
            invalid = true;
            return { ...questao };
          } else if (questao.valrRespostaItemQuest !== null || questao.valrRespostaItemQuest !== "") {
            questao.valrRespostaItemQuest = questao.data.trim();

            if (questao.valrRespostaItemQuest === "Sim" && questao.type === "LISTA") {
              if (arquivo) {
                // console.log("ArquivoSelecao: " + arquivo.name);
                // console.log("ArquivoBanco: " + v_nomeArquivo);
                // console.log("ArquivoSelecionadoNovo: " + v_nomeArquivoNovo)
                //Comparacao pelo nome do arquivo para fazer Upload ou nao do arquivo selecionado
                if (
                  questao.idenArquivo === null ||
                  (questao.idenArquivo !== null && v_nomeArquivo !== v_nomeArquivoNovo)
                ) {
                  try {
                    idArquivo = await uploadArquivoRAG(arquivo);
                  } catch (error) {
                    console.error(`Erro no upload: ${error.message}`);
                  }
                }
              }
            }
            return { ...questao };
          }
        })
      );

      // Exibe todos os erros juntos no printToast
      if (invalid) {
        errorMessages.forEach((msg) => {
          printToast({ severity: "error", summary: "OBRIGATÓRIO", detail: msg });
        });
      }

      let codigoItem = campos[0].codigoItemRag;

      //Tratamento para controlar se eh arquivo novo ou atualizacao do mesmo arquivo
      let idAux = 0;
      if (idArquivo != null) {
        if (idArquivo > 0) {
          idAux = idArquivo;
          //console.log("RotinaDeCriacaoNovoArquivo: " + idArquivo);
        }
      } else {
        idAux = v_idenArquivo;
        //console.log("Rotina de atualizacao, NAOCRIA um novo arquivo: " + v_idenArquivo)
      }

      // Atualize o campo idenArquivo com idAux
      v_campos = v_campos.map((questao) => {
        if (questao.valrRespostaItemQuest === "Sim" && questao.type === "LISTA") {
          return {
            ...questao,
            idenArquivo: idAux,
          };
        }
        return questao;
      });
      //console.log("ALTERADOVCAMPOS")
      //console.log(v_campos)
      //debugger

      if (!exercicio2024) {
        try {
          (await !invalid) &&
            salvarAvaliacaoAcao(codigoItem, v_campos, idAux).then((res) => {
              props.setCamposQuestionarioMetaFisica(JSON.stringify(v_campos));
              //console.log("Atualizou com RespostaAtualizadaComArquivo: " + idAux);
              setIdenArquivo(idAux);
              setArquivoSelecionado(false);
              printToast({ summary: "Ação Efetuada", detail: "Avaliação da Meta Física salva com sucesso" });
            });
        } catch (error) {
          console.error(`Erro ao salvar a avaliação: ${error.message}`);
        }
      } else {
        //console.log("Parte2024 produto: " + produtoSelecionado.ptaFiplan.codgExercicio + " " + produtoSelecionado.ptaFiplan.codgElemento + " " + produtoSelecionado.ptaFiplan.idenPtaFiplan + " " + idAux + " " + produtoSelecionado.ptaFiplan.produto.idenProduto)
        try {
          (await !invalid) &&
            salvarAvaliacaoAcao2024(
              produtoSelecionado.ptaFiplan.idenPtaFiplan,
              v_campos,
              idAux,
              produtoSelecionado.ptaFiplan.produto.idenProduto
            ).then((res) => {
              props.setCamposQuestionarioMetaFisica(JSON.stringify(v_campos));
              //console.log("Atualizou com RespostaAtualizadaComArquivo: " + idAux);
              setIdenArquivo(idAux);
              setArquivoSelecionado(false);
              props.aba(true); //Controle para sinalizar que a Aba Identificacao deve realizar a busca do percentual de preenchimento do acao
              //console.log("ConfirmouTelaMetaFisica")
              printToast({ summary: "Ação Efetuada", detail: "Avaliação da Meta Física salva com sucesso" });
            });
        } catch (error) {
          console.error(`Erro ao salvar a avaliação: ${error.message}`);
        }
      }
    }
  };

  function atualizarListaRegiao(item, valor) {
    item.valrRealizadoTxt = VlrRealizadoFormatado(valor);
    let lista = listaMetaPtaFiplanRegPlan.map((obj) => {
      if (obj.idView === item.idView) {
        obj.valrRealizadoTxt = VlrRealizadoFormatado(valor);
      }
      return obj;
    });
    setListaMetaPtaFiplanRegPlan(lista);
  }

  function atualizarListaProdutoAnalise(item) {
    let lista = listaProdutosAnalise.map((obj) => (obj.idView === item.idView ? { ...obj, ...item } : obj));
    setListaProdutosAnalise(lista);
    // console.log("Atualiza: ", listaProdutosAnalise);
  }

  function atualizarListaProdutoAnalise2024(item) {
    //console.log(listaProdutos)
    let lista = Object.assign(listaProdutos);
    lista = lista.filter(
      (obj) => obj.idView === item.value.idView && obj.ptaFiplan.codgElemento === item.value.ptaFiplan.codgElemento
    );
    setListaProdutosAnalise(lista);
    // console.log("Atualiza2024: ", lista);
  }

  const valrRealizadoTxtTemplate = (rowData) => {
    if (rowData.descRegiaoPlanejamento === "TOTAL") {
      return (
        <>
          {rowData.valrRealizadoTxt !== 0.0
            ? rowData.valrRealizadoTxt.toLocaleString("pt-BR", { minimumFractionDigits: 2 })
            : "-"}
        </>
      );
    } else {
      return (
        <>
          <InputText
            className="input-mask"
            maxLength={22}
            onChange={(e) => atualizarListaRegiao(rowData, e.target.value)}
            value={rowData.valrRealizadoTxt}
            onBlur={(e) => {
              atualizarListaProdutoAnalise(rowData);
              calcularTotal(rowData.ptaMonitora.ptaFiplan.idenPtaFiplan);
            }}
            disabled={!props.podeAvaliarAcao}
          />
        </>
      );
    }
  };

  function salvarTabelaRegiaoPlanejamento() {
    let dados = listaMetaPtaFiplanRegPlan
      .filter((item) => item.descRegiaoPlanejamento !== "TOTAL")
      .map((element) => {
        // trecho comentado, pois não estava permitindo a inserção de valores zerados
        //if(!(element.valrRealizadoTxt == '0,00' || element.valrRealizadoTxt == '0.00' || element.valrRealizadoTxt == '')){
        element.realizadoPtaMonRgPla.valrRealizado = element.valrRealizadoTxt.replaceAll(".", "").replace(",", ".");
        //}
        let mapReturn = {
          ptaMonitora: {
            idenPtaMonitora: element.ptaMonitora.idenPtaMonitora,
          },
          realizadoPtaMonRgPla: element.realizadoPtaMonRgPla,
          regiaoPlanejamento: element.regiaoPlanejamento,
        };

        return { ...mapReturn };
      });

    salvarRealizadoRegiaoPlan(dados).then((res) => {
      printToast({ summary: "Ação Efetuada", detail: "Metas regionais salvas com sucesso" });
    });
  }

  const onUpload = (e) => {
    setArquivo(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      //console.log(e.target.files[0])
      setNomeArquivoNovo(e.target.files[0].name); //recupera o nome do arquivo selecionado
      //console.log("arqquivo03 " + v_nomeArquivoNovo)
      setArquivoSelecionado(true);
      // console.log("arquivoSelecionado", arquivoSelecionado)
    }
  };
  //console.log("arqquivo04 " + v_nomeArquivoNovo + " .")

  //Controle para identificar se o ano eh igual ou superior a 2024
  const exercicio2024 = props.dadosItemAcao.ptaFiplan.codgExercicio >= 2024 ? true : false;

  {
    /* Pegar o Id da Resposta 03 */
  }

  // console.log("IdRecuperado: " + v_idArquivo)

  // console.log("campos",campos)
  return (
    <>
      <CardSeplagScrol title="Produto para Análise">
        <Accordion multiple>
          <AccordionTab header="Previsto x Realizado">
            <div className="p-fluid grid">
              <div className="field col-12">
                <Rotulo nome="Produto">
                  <Dropdown
                    emptyMessage="Dados não encontrados"
                    emptyFilterMessage="Opção não encontrada"
                    id="selProduto"
                    value={produtoSelecionado}
                    options={listaProdutos}
                    onChange={onChangeProduto}
                    optionLabel="ptaFiplan.descElemento"
                    // optionLabel={(option) => `${option.ptaFiplan.codgElemento} - ${option.ptaFiplan.descElemento}`}
                    filter
                    showClear
                    filterBy="ptaFiplan.descElemento"
                    placeholder="Selecione o Produto"
                  />
                  {/* {console.log("Combobox: ", listaProdutos)}                   */}
                </Rotulo>
              </div>
            </div>
            {listaMetaPtaFiplanRegPlan != null && (
              <>
                <DataTable value={listaMetaPtaFiplanRegPlan} stripedRows showGridlines>
                  <Column field="descRegiaoPlanejamento" header="Região de Planejamento" />
                  <Column
                    field="valrMetaOriginal"
                    body={(e) =>
                      e.valrMetaOriginal != 0.0
                        ? e.valrMetaOriginal.toLocaleString("pt-BR", { minimumFractionDigits: 2 })
                        : "-"
                    }
                    header="Quantidade Meta PTA/LOA"
                  />
                  <Column
                    field="valrMetaAtualizada"
                    body={(e) =>
                      e.valrMetaAtualizada != 0.0
                        ? e.valrMetaAtualizada.toLocaleString("pt-BR", { minimumFractionDigits: 2 })
                        : "-"
                    }
                    header="Quantidade Meta Atualizada/PTAG"
                  />
                  <Column field="valrRealizadoTxt" body={valrRealizadoTxtTemplate} header="Quantidade Realizado" />
                </DataTable>
                <br />
                <div className="p-fluid grid">
                  <div className="field col-12 md:col-10 "></div>

                  <div className="field col-12 md:col-2 ">
                    <Button
                      label="Salvar Meta Regional"
                      className="p-button-success"
                      onClick={() => salvarTabelaRegiaoPlanejamento()}
                      disabled={!props.podeAvaliarAcao}
                    />
                  </div>
                </div>

                <DataTable value={vlrTotal} stripedRows showGridlines>
                  <Column
                    field="ProdutoPrevistoInicial"
                    body={(e) =>
                      new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2 }).format(e.ProdutoPrevistoInicial)
                    }
                    header="Produto Previsto Inicial"
                  />
                  <Column
                    field="ProdutoPrevistoAtualizado"
                    body={(e) =>
                      new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2 }).format(e.ProdutoPrevistoAtualizado)
                    }
                    header="Produto Previsto Atualizado"
                  />
                  <Column
                    field="ProdutoPrevistoRealizado"
                    body={(e) => formatarValor(e.ProdutoPrevistoRealizado.toFixed(2))}
                    header="Produto Realizado"
                  />
                  <Column
                    field="PercRealizadoPrevistoInicial"
                    body={(e) => formatarValor(e.PercRealizadoPrevistoInicial.toFixed(2))}
                    header="% Realizado / Previsto Inicial"
                  />
                  <Column
                    field="PercRealizadoPrevistoAtualizado"
                    body={(e) =>
                      e.PercRealizadoPrevistoAtualizado != "Infinity"
                        ? formatarValor(e.PercRealizadoPrevistoAtualizado.toFixed(2))
                        : "0,00"
                    }
                    header="% Realizado / Previsto Atualizado"
                  />
                </DataTable>

                {!exercicio2024 ? (
                  <div className="div-regua">
                    <div className="div-titulo-grafico">
                      <h3>% Realizado / Previsto Inicial</h3>
                    </div>

                    <div className="wrapper div-color">
                      <div style={{ width: "10%" }}>
                        <div className="div-red"> 60.000% </div>
                        <div className="div-grafico-rodape"> Deficiente</div>
                        {isPercent.PrevistoInicial.percent60 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoInicial.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "7.5%" }}>
                        <div className="div-yellow"> 80.000%</div>
                        <div className="div-grafico-rodape"> Regular</div>
                        {isPercent.PrevistoInicial.percent80 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoInicial.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "6" }}>
                        <div className="div-green"> 90.000%</div>
                        <div className="div-grafico-rodape"> Bom</div>
                        {isPercent.PrevistoInicial.percent90 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoInicial.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "6%" }}>
                        <div className="div-blue"> 100.000%</div>
                        <div className="div-grafico-rodape"> Ótimo</div>
                        {isPercent.PrevistoInicial.percent100 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoInicial.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "6%" }}>
                        <div className="div-green"> 110.000%</div>
                        <div className="div-grafico-rodape"> Bom</div>
                        {isPercent.PrevistoInicial.percent110 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoInicial.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "7.5%" }}>
                        <div className="div-yellow"> 120.000%</div>
                        <div className="div-grafico-rodape"> Regular</div>
                        {isPercent.PrevistoInicial.percent120 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoInicial.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "10%" }}>
                        <div className="div-red"> 140.000%</div>
                        <div className="div-grafico-rodape"> Deficiente</div>
                        {isPercent.PrevistoInicial.percent140 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoInicial.toFixed(2))}</label>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="div-titulo-grafico" style={{ marginTop: "40px" }}>
                      <h3>% Realizado / Previsto atualizado</h3>
                    </div>

                    <div className="wrapper div-color">
                      <div style={{ width: "10%" }}>
                        <div className="div-red"> 60.000% </div>
                        <div className="div-grafico-rodape"> Deficiente</div>
                        {isPercent.PrevistoAtualizado.percent60 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoAtualizado.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "7.5%" }}>
                        <div className="div-yellow"> 80.000%</div>
                        <div className="div-grafico-rodape"> Regular</div>
                        {isPercent.PrevistoAtualizado.percent80 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoAtualizado.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "6%" }}>
                        <div className="div-green"> 90.000%</div>
                        <div className="div-grafico-rodape"> Bom</div>
                        {isPercent.PrevistoAtualizado.percent90 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoAtualizado.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "6%" }}>
                        <div className="div-blue"> 100.000%</div>
                        <div className="div-grafico-rodape"> Ótimo</div>
                        {isPercent.PrevistoAtualizado.percent100 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoAtualizado.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "7%" }}>
                        <div className="div-green"> 110.000%</div>
                        <div className="div-grafico-rodape"> Bom</div>
                        {isPercent.PrevistoAtualizado.percent110 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoAtualizado.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "7.5%" }}>
                        <div className="div-yellow"> 120.000%</div>
                        <div className="div-grafico-rodape"> Regular</div>
                        {isPercent.PrevistoAtualizado.percent120 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoAtualizado.toFixed(2))}</label>
                          </div>
                        )}
                      </div>

                      <div style={{ width: "10%" }}>
                        <div className="div-red"> 140.000%</div>
                        <div className="div-grafico-rodape"> Deficiente</div>
                        {isPercent.PrevistoAtualizado.percent140 && (
                          <div>
                            <i className="pi pi-arrow-up"></i>
                            <label> {formatarValor(porcentagemPrevistoAtualizado.toFixed(2))}</label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <hr />
                    <Regua2024
                      atributos={[
                        { titulo: `% Realizado / Previsto Inicial`, porcentagemPrevisto: porcentagemPrevistoInicial },
                        {
                          titulo: `% Realizado / Previsto Atualizado`,
                          porcentagemPrevisto: porcentagemPrevistoAtualizado,
                        },
                      ]}
                    />
                  </>
                )}
              </>
            )}
          </AccordionTab>
          <AccordionTab
            header="Análise da Meta Física"
            disabled={!produtoSelecionado} // Desabilita o AccordionTab se produtoSelecionado for null
            onClick={() => {
              if (!produtoSelecionado) {
                printToast({
                  summary: "Ação Bloqueada",
                  detail: "Selecione um Produto para acessar essa análise.",
                  severity: "warn",
                });
              }
            }}
          >
            {listaProdutosAnalise && (
              <DataTable
                value={listaProdutosAnalise}
                stripedRows
                showGridlines
                emptyMessage="Nenhum registro encontrado"
              >
                <Column header="Produtos para Análise" field="ptaFiplan.descElemento"></Column>
                <Column header="Unidade de Medida" field="ptaFiplan.unidadeMedida.descUnidadeMedida"></Column>
                <Column
                  header="Previsto Inicial"
                  field="produtoAcaoRegiao"
                  body={(e) =>
                    formatarValor(e.produtoAcaoRegiao.reduce((acc, current) => acc + current.valrMetaOriginal, 0))
                  }
                ></Column>
                <Column
                  header="Previsto Atualizado"
                  field="produtoAcaoRegiao"
                  body={(e) =>
                    formatarValor(e.produtoAcaoRegiao.reduce((acc, current) => acc + current.valrMetaAtualizada, 0))
                  }
                ></Column>
                <Column
                  header="Realizado"
                  field="produtoAcaoRegiao"
                  body={
                    (e) =>
                      e.valrRealizado == null
                        ? formatarValor(e.produtoAcaoRegiao.reduce((acc, current) => acc + current.valrRealizado, 0)) //busca o valor do banco
                        : formatarValor(e.valrRealizado, 0) //busca o valor atualizado em tela
                  }
                ></Column>
              </DataTable>
            )}
            <QuestionarioSeplag
              campos={campos}
              setCampos={setCampos}
              condicao={props.condicao}
              IsMaximoCaracteres={true}
              qtdMaxCaracteres={10000}
              onUpload={(option) => onUpload(option)}
              arquivo={arquivoSelecionado && arquivo}
              idArquivoQuestinario={v_idenArquivo}
              isDisabled={!props.podeAvaliarAcao}
              codUnidadeAcao={{
                unidade: props.dadosItemAcao.ptaFiplan.codgUo,
                acao: props.dadosItemAcao.ptaFiplan.codgElemento,
              }} //passa o codigo da unidade e acao via props, para ser utilizado posteriormente
            ></QuestionarioSeplag>
            <br />
            <div className="p-fluid grid">
              <div className="field col-12 md:col-10 ">&nbsp;</div>

              <div className="field col-12 md:col-2 ">
                <Button
                  label="Salvar"
                  className="p-button-success"
                  onClick={salvar}
                  disabled={!props.podeAvaliarAcao}
                />
              </div>
            </div>
            {!produtoSelecionado && (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <span>Selecione um Produto para visualizar esta análise.</span>
              </div>
            )}
          </AccordionTab>
        </Accordion>
        <br />
        <div className="p-fluid grid">
          <div className="field col-12 md:col-10 ">&nbsp;</div>

          <div className="field col-12 md:col-2 ">
            <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
          </div>
        </div>
      </CardSeplagScrol>
    </>
  );
};

export default AvaliacaoAcaoRagMetaFisica;
